import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'status',
})
export class StatusPipe implements PipeTransform {
	transform(value: any): any {
		return value.state;
	}
}
